import React from 'react';
import { ShieldCheck } from 'lucide-react';
const insurances = ['Aetna', 'BlueCross BlueShield', 'Cigna', 'Delta Dental', 'Guardian', 'Metlife', 'DC Medicaid'];
export function InsuranceRibbon() {
  // Duplicate the array to create a seamless infinite loop (50% translation)
  const duplicatedInsurances = [...insurances, ...insurances];
  return <div className="bg-[#0F2C59] py-4 overflow-hidden border-t-4 border-[#0D9488]" data-id="element-167">
      <div className="flex whitespace-nowrap animate-marquee items-center" data-id="element-168">
        {duplicatedInsurances.map((insurance, idx) => <div key={idx} className="flex items-center mx-8" data-id="element-169">
            <ShieldCheck size={16} className="text-[#0D9488] mr-2" data-id="element-170" />
            <span className="text-white/90 font-bold tracking-wider uppercase text-sm" data-id="element-171">
              {insurance}
            </span>
            <span className="mx-8 text-white/20" data-id="element-172">|</span>
          </div>)}
      </div>
    </div>;
}